export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const homeGames = {
  crash: [
    {
      href: "/casino/aggapturbogames-aero-u9978",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/areogame.jpg",
      alt: "aviator",
      name: "Aviator",
    },
    {
      href: "/casino/aggapmac88gamingvirtual-pushpa-rani",
      code: "",
      casino: "Mac88 Gaming Virtual",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/pushpa-rani.webp",
      alt: "pushpa rani",
      name: "Pushpa Rani",
    },
    {
      href: "/casino/awc-cock-fight-phi",
      code: "",
      casino: "AE Sexy Casino",
      provider: "WorldCasino",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/crash/cockfight.png",
      alt: "Cock Fight",
      name: "Cock Fight PHI",
    },
    {
      href: "/casino/aggapcrash88gaming-aviatorx",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/newgames/aviatrix.png",
      alt: "AviatorX",
      name: "AviatorX",
    },
    {
      href: "/casino/aggapturbogames-aero-u9978",
      code: "",
      casino: "Spribe",
      provider: "Spribe",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/newgames/Aero.png",
      alt: "Aviator",
      name: "Aviator",
    },
    {
      href: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "Smartsoft",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/newgames/JetX.webp",
      alt: "JetX",
      name: "JetX",
    },
    {
      href: "/casino/spribe-aviator",
      code: "",
      casino: "Ezugi",
      provider: "qtech",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/newgames/aviator.webp",
      alt: "Aviatorx",
      name: "Aviatorx",
    },
  ],
  roulette: [
    {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/AmericanRoulette.webp",
      alt: "american roulette",
      name: "American Roulette",
    },
    {
      href: "/casino/ezgevo-auto-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/AutoRoulette.webp",
      alt: "auto roulette",
      name: "Auto Roulette",
    },
    {
      href: "/casino/aggapezugi-marina-casino-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/CasinoMarinaRoulette1.webp",
      alt: "casino marina roulette 1",
      name: "Casino Marina Roulette 1",
    },
    {
      href: "/casino/aggapezugi-marina-casino-roulette2",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/CasinoMarinaRoulette2.webp",
      alt: "casino marina roulette 2",
      name: "Casino Marina Roulette 2",
    },
    {
      href: "/casino/aggapezugi-cricket-auto-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/CricketAutoRoulette.webp",
      alt: "cricket auto roulette",
      name: "Cricket Auto Roulette",
    },
    {
      href: "/casino/aggapezugi-ruleta-del-sol",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/RuletaDelSol.webp",
      alt: "ruleta del sol",
      name: "Ruleta Del Sol",
    },
    {
      href: "/casino/aggapezugi-diamond-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/DiamondRoulette.webp",
      alt: "diamond roulette",
      name: "Diamond Roulette",
    },
    {
      href: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/DoubleBallRoulette.webp",
      alt: "double ball roulette",
      name: "Double Ball Roulette",
    },
    {
      href: "/casino/ezgevo-first-person-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/FirstPersonRoulette.webp",
      alt: "first person roulette",
      name: "First Person Roulette",
    },
    {
      href: "/casino/aggapezugi-italian-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/ItalianRoulette.webp",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    {
      href: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/LightningRoulette.webp",
      alt: "lightning roulette",
      name: "Lightning Roulette",
    },
    {
      href: "/casino/aggapezugi-namaste-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/NamasteRoulette.webp",
      alt: "namaste roulette",
      name: "Namaste Roulette",
    },
    {
      href: "/casino/aggapezugi-oracle-casino-roulette-360",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/Oracle360Roulette.webp",
      alt: "oracle 360 roulette",
      name: "Oracle 360 Roulette",
    },
    {
      href: "/casino/aggapezugi-prestige-auto-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/PrestigeAutoRoulette.webp",
      alt: "prestige auto roulette",
      name: "Prestige Auto Roulette",
    },
    {
      href: "/casino/aggapezugi-skyline-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/SkylineRoulette.webp",
      alt: "skyline roulette",
      name: "Skyline Roulette",
    },
    {
      href: "/casino/aggapezugi-speed-auto-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/SpeedAutoRoulette.webp",
      alt: "speed auto roulette",
      name: "Speed Auto Roulette",
    },
    {
      href: "/casino/aggapezugi-speed-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/SpeedRoulette.webp",
      alt: "speed roulette",
      name: "Speed Roulette",
    },
    {
      href: "/casino/aggapezugi-turkce-rulet",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/TurkishRoulette.webp",
      alt: "turkish roulette",
      name: "Turkish Roulette",
    },
    {
      href: "/casino/aggapezugi-ultimate-roulette",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/roulette/home/UltimateRoulette.webp",
      alt: "ultimate roulette",
      name: "Ultimate Roulette",
    },
  ],
  andarbahar: [
    {
      href: "/casino/aggapevolutiongaming-super-andar-bahar-u6070",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/andarbahar/home/superandharbhar.jpg",
      alt: "super andar bahar",
      name: "Super Andar Bahar",
    },
    {
      href: "/casino/aggapezugi-andar-bahar",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/andarbahar/home/AndarBahar.webp",
      alt: "andar bahar",
      name: "Andar Bahar",
    },
    {
      href: "/casino/aggapezugi-ott-andar-bahar",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/andarbahar/home/OTTAndarBahar.webp",
      alt: "ott andar bahar",
      name: "OTT Andar Bahar",
    },
    {
      href: "/casino/aggapezugi-ultimate-andar-bahar",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/andarbahar/home/UltimateAndarBahar.webp",
      alt: "ultimate andar bahar",
      name: "Ultimate Andar Bahar",
    },
  ],
  teenpatti: [
    {
      href: "/casino/aggapmac88gaming-20-20-teenpatti",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/poker/home/2020teenpatti.jpg",
      alt: "20-20 Teenpatti",
      name: "20-20 Teenpatti",
    },
    {
      href: "/casino/aggapezugi-bet-on-teen-patti",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/poker/home/BetOnTeenPatti.webp",
      alt: "bet on teen patti",
      name: "Bet On Teen Patti",
    },
    {
      href: "/casino/aggapezugi-one-day-teen-patti-classic",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/poker/home/OneDayTeenPatti.webp",
      alt: "one day teen patti",
      name: "One Day Teen Patti",
    },
    {
      href: "/casino/aggapezugi-teen-patti",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/poker/home/TeenPatti3Card.webp",
      alt: "teen patti 3 card",
      name: "Teen Patti 3 Card",
    },
  ],
  baccarat: [
    {
      href: "/casino/aggapplaytechlive-grand-baccarat",
      code: "",
      casino: "Playtech Live",
      provider: "ALT_GAMING_GAP",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/livebaccaratNew.webp",
      alt: "Live Baccarat",
      name: "Live Baccarat",
    },
    {
      href: "/casino/aggapezugi-dragon-tiger",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/dragontiger.jpg",
      alt: "dragon tiger",
      name: "Dragon Tiger",
    },
    {
      href: "/casino/aggapezugi-baccarat",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/Baccarat1.webp",
      alt: "baccarat",
      name: "Baccarat",
    },
    {
      href: "/casino/ezgevo-baccarat-control-squeeze",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/BaccaratControlSqueeze.webp",
      alt: "baccarat control squeeze",
      name: "Baccarat Control Squeeze",
    },
    {
      href: "/casino/aggapezugi-baccarat-knockout",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/KnockoutBaccarat.webp",
      alt: "knockout baccarat",
      name: "Knockout Baccarat",
    },
    {
      href: "/casino/aggapezugi-marina-casino-baccarat-1",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/CasinoMarinaBaccarat1.webp",
      alt: "casino marina baccarat 1",
      name: "Casino Marina Baccarat 1",
    },
    {
      href: "/casino/aggapezugi-marina-casino-baccarat-2",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/CasinoMarinaBaccarat2.webp",
      alt: "casino marina baccarat 2",
      name: "Casino Marina Baccarat 2",
    },
    {
      href: "/casino/aggapezugi-cricket-war",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/CricketWar.webp",
      alt: "cricket war",
      name: "Cricket War",
    },

    {
      href: "/casino/aggapezugi-fortune-baccarat",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/FortuneBaccarat.webp",
      alt: "fortune baccarat",
      name: "Fortune Baccarat",
    },
    {
      href: "/casino/aggapezugi-no-commission-baccarat-a",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/NoCommissionBaccarat.webp",
      alt: "no commission baccarat",
      name: "No Commission Baccarat",
    },
    {
      href: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/SpeedBaccaratA.webp",
      alt: "speed baccarat a",
      name: "Speed Baccarat A",
    },
    {
      href: "/casino/aggapezugi-baccarat-super-six",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/baccarat/home/Super6Baccarat.webp",
      alt: "super 6 baccarat",
      name: "Super 6 Baccarat",
    },
  ],
  lucky7: [
    {
      href: "/casino/aggapezugi-lucky-7",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/lucky7/home/Lucky7.webp",
      alt: "lucky 7",
      name: "Lucky 7",
    },
  ],
  dice: [
    {
      href: "/casino/ezgevo-gonzos-lightning-sic-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/dice/home/lightningsicbo.jpg",
      alt: "lightning  sicbo",
      name: "Lightning  SicBo",
    },
    {
      href: "/casino/ezgevo-lightning-dice",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/dice/home/LightningDice.webp",
      alt: "lightning dice",
      name: "Lightning Dice",
    },
    {
      href: "/casino/aggapezugi-sic-bo",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/dice/home/SicBo.webp",
      alt: "sic bo",
      name: "Sic Bo",
    },
    {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/dice/home/SuperSicBo.webp",
      alt: "super sic bo",
      name: "Super Sic Bo",
    },
    {
      href: "/casino/aggapezugi-ultimate-sic-bo",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/dice/home/UltimateSicBo.webp",
      alt: "ultimate sic Ubo",
      name: "Ultimate Sic Bo",
    },
  ],

  blackjack: [
    {
      href: "/casino/ezgevo-blackjack-party",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/BlackjackParty.webp",
      alt: "blackjack party",
      name: "Blackjack Party",
    },
    {
      href: "/casino/ezgevo-classic-speed-blackjack-2",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/ClassicSpeedBlackjack10.webp",
      alt: "classic speed blackjack 2",
      name: "Classic Speed Blackjack 2",
    },
    {
      href: "/casino/aggapezugi-vip-blackjack",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/DiamondVIPBlackjack.webp",
      alt: "vip diamond blackjack",
      name: "VIP Diamond Blackjack",
    },
    {
      href: "/casino/ezgevo-free-bet-blackjack-1",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/FreeBetBlackjack1.webp",
      alt: "free bet blackjack 1",
      name: "Free Bet Blackjack 1",
    },
    {
      href: "/casino/aggapezugi-blackjack-gold-3",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/GoldBlackjack3.webp",
      alt: "gold blackjack 3",
      name: "Gold Blackjack 3",
    },
    {
      href: "/casino/aggapezugi-blackjack-gold-5",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/GoldBlackjack5.webp",
      alt: "gold blackjack 5",
      name: "Gold Blackjack 5",
    },
    {
      href: "/casino/aggapezugi-salon-prive-blackjack",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/SalonePriveBlackjack.webp",
      alt: "salon prive blackjack",
      name: "Salon Prive Blackjack",
    },
    {
      href: "/casino/aggapezugi-unlimited-blackjack",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/UnlimitedBlackjack.webp",
      alt: "unlimited blackjack",
      name: "Unlimited Blackjack",
    },
    {
      href: "/casino/aggapezugi-vip-blackjack-with-surrender",
      code: "",
      casino: "Ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/blackjack/home/VIPSurrenderBlackjackwith.webp",
      alt: "vip surrender blackjack",
      name: "VIP Surrender Blackjack",
    },
  ],
  gameshows: [
    // {
    //   href: "/casino/ezgevo-cash-or-crash",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/gameshows/home/CashOrCrash.webp",
    //   alt: "cash or crash",
    //   name: "Cash Or Crash",
    // },
    {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/gameshows/home/CrazyTime.webp",
      alt: "crazy time",
      name: "Crazy Time",
    },
    {
      href: "/casino/ezgevo-dream-catcher",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/gameshows/home/DreamCatcher.webp",
      alt: "dream catcher",
      name: "Dream Catcher",
    },
    {
      href: "/casino/ezgevo-football-studio",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/gameshows/home/FootballStudio.webp",
      alt: "football studio",
      name: "Football Studio",
    },
    {
      href: "/casino/ezgevo-mega-ball",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/gameshows/home/MegaBall.webp",
      alt: "mega ball",
      name: "Mega Ball",
    },
    {
      href: "/casino/ezgevo-monopoly-live",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/gameshows/home/monopolygame.webp",
      alt: "Monopoly Live",
      name: "Monopoly Live",
    },
    // {
    //   href: "/casino/ezgevo-side-bet-city",
    //   code: "",
    //   casino: "Evolution",
    //   provider: "Ezugi",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/gameshows/home/SideBetCity.webp",
    //   alt: "side bet city",
    //   name: "Side Bet City",
    // },
  ],

  vivo: [
    {
      name: "Las Vegas Roulette",
      href: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/LasVegasRolette-new.webp",
      alt: "Las Vegas Roulette",
    },
    {
      name: "Blaze Roulette",
      href: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/BlazeRoulette-new.webp",
      alt: "Blaze Roulette",
    },
    {
      name: "Baccarat Dance",
      href: "/casino/vivo-baccarat-dance",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/BaccaratDance-new.webp",
      alt: "Baccarat Dance",
    },
    {
      name: "Imperial Dragon Tiger",
      href: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/imperialdragontiger-new.webp",
      alt: "Imperial Dragon Tiger",
    },
    {
      name: "Caribbean Baccarat",
      href: "/casino/vivo-caribbean-baccarat",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/CaribbeanBaccarat-new.webp",
      alt: "Caribbean Baccarat",
    },
    {
      name: "Copa Cabana Baccarat",
      href: "/casino/vivo-copa-cabana-baccarat",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/CopaCabanaBaccarat-new.webp",
      alt: "Copa Cabana Baccarat",
    },
    {
      name: "Oracle Twister Roulette",
      href: "/casino/vivo-oracle-360-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/OracleTwisterRoulette-new.webp",
      alt: "Oracle Twister Roulette",
    },
    {
      name: "Portomaso Roulette",
      href: "/casino/vivo-portomaso-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/PortomasoRoulette-new.webp",
      alt: "Portomaso Roulette",
    },
    {
      name: "European Auto Roulette",
      href: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "Vivo",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/new/EuropeanAutoRoulette-new.webp",
      alt: "European Auto Roulette",
    },
  ],

  vimplay: [
    {
      href: "/casino/vimplayvimplay-techno-roulette",
      imgUrl: "./images/vimplay/texhnoroulette.jpg",
      name: "TECHNO ROULETTE",
    },
    {
      href: "/casino/vimplayvimplay-royal-roulette",
      imgUrl: "./images/vimplay/RoyalRoulette.jpg",
      name: "ROYAL ROULETTE",
    },
    {
      href: "/casino/vimplayvimplay-replay-roulette",
      imgUrl: "./images/vimplay/ReplayRoullete.jpg",
      name: "REPLAY ROULETTE",
    },
    {
      href: "/casino/vimplayvimplay-cosmic-roulette",
      imgUrl: "./images/vimplay/cosmicroulette.jpg",
      name: "COSMIC ROULETTE",
    },
    {
      href: "/casino/vimplayvimplay-rouletto",
      imgUrl: "./images/vimplay/rouletto.jpg",
      name: "ROULETTO",
    },
    {
      href: "/casino/vimplayvimplay-bombrunner",
      imgUrl: "./images/vimplay/BombRun.jpg",
      name: "BOMB_RUNNER",
    },
    {
      href: "/casino/vimplayvimplay-wishingwell",
      imgUrl: "./images/vimplay/Wishingwell.jpg",
      name: " WISHING_WELL",
    },
    {
      href: "/casino/vimplayvimplay-crash-kick",
      imgUrl: "./images/vimplay/crashkick.jpg",
      name: "CRASH KICK",
    },
    {
      href: "/casino/vimplayvimplay-lottoluck",
      imgUrl: "./images/vimplay/lottoluck.jpg",
      name: "LOTTO_LUCK",
    },
    {
      href: "/casino/vimplayvimplay-dragontap",
      imgUrl: "./images/vimplay/dragontap.jpg",
      name: "DRAGON_TAP",
    },
  ],
  spribe: [
    {
      // href: "/casino/aggapspribe-aviator",
      href: "/casino/aggapspribe-aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator-new.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-goal",
      href: "/casino/aggapspribe-goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Goal-new.webp",
      alt: "",
      name: "Goal",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-dice",
      href: "/casino/aggapspribe-dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Dice-new.webp",
      alt: "",
      name: "Dice",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-plinko",
      href: "/casino/aggapspribe-plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Plinko-new.webp",
      alt: "",
      name: "Plinko",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-hilo",
      href: "/casino/aggapspribe-hilo",
      code: "hi-lo",
      casino: "spribe",
      provider: "hi-lo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Hilo-new.webp",
      alt: "",
      name: "Hilo",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-keno",
      href: "/casino/aggapspribe-keno",
      code: "keno",
      casino: "spribe",
      provider: "keno",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Keno-new.webp",
      alt: "keno",
      name: "Keno",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-miniroulette",
      href: "/casino/aggapspribe-mini-roulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "mini-roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/MiniRoulette-new.webp",
      alt: "",
      name: "Mini Roulette",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-mines",
      href: "/casino/aggapspribe-mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Mines.webp",
      alt: "",
      name: "Mines",
      providerName: "Spribe",
    },
    {
      // href: "/casino/aggapspribe-hotline",
      href: "/casino/aggapspribe-hotline",
      code: "hotline",
      casino: "spribe",
      provider: "hotline",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/HotlineNew.jpg",
      alt: "hotline",
      name: "Hotline",
      providerName: "Spribe",
    },
    {
      href: "/casino/aggapspribe-pilot-chicken",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/pilotchicken.webp",
      alt: "Pilot Chicken",
      name: "Pilot Chicken",
    },
    {
      href: "/casino/aggapspribe-gates-of-egypt",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/gatesofegypt.webp",
      alt: "Gates of Egypt",
      name: "Gates of Egypt",
    },
    {
      href: "/casino/aggapspribe-neo-vegas",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/neovegas.webp",
      alt: "Neo Vegas",
      name: "Neo Vegas",
    },
    {
      href: "/casino/aggapspribe-crystal-fall",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/crystalfall.webp",
      alt: "Crystal Fall",
      name: "Crystal Fall",
    },
    {
      href: "/casino/aggapspribe-trader",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/trader.webp",
      alt: "Trader",
      name: "Trader",
    },
    {
      href: "/casino/aggapspribe-keno-80",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/multikeno.webp",
      alt: "Keno 80",
      name: "Keno 80",
    },
    {
      href: "/casino/aggapspribe-balloon",
      code: "",
      casino: "spribe",
      provider: "alt-gaming",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "/images/spribe/balloon.webp",
      alt: "Balloon",
      name: "Balloon",
    },
  ],
  anviogames: [
    {
      name: "Zhandu",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Zhandu.webp",
      href: "/casino/anvioanvio-zhandu",
    },
    {
      name: "Teenpatti",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/teenpatti.webp",
      href: "/casino/anvioanvio-teenpatti",
    },
    {
      name: "Dragon Tiger",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/dragontiger.webp",
      href: "/casino/anvioanvio-dragon-tiger",
    },
    {
      name: "Dana",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/dana.webp",
      href: "/casino/anvioanvio-dana",
    },
    {
      name: "Roulette",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Roulette.webp",
      href: "/casino/anvioanvio-roulette",
    },
    {
      name: "7 Up & Down",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/sevenupdown.webp",
      href: "/casino/anvioanvio-7-up-and-down",
    },
    {
      name: "Teenpatti 2",
      providerName: "Anvio",
      imgUrl: "./images/anvio-games/Teenpatti2.webp",
      href: "/casino/anvioanvio-teenpatti2",
    },
  ],
};
